import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import transformDate from "../../../helpers/transform-date";

const toBase64 = (url: string): Promise<string> =>
  fetch(url)
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        }),
    );

const handleDownloadPDF = async (data: any, user: any) => {
  const reportElement = document.createElement("div");
  reportElement.style.width = "600px";
  reportElement.style.padding = "20px";
  reportElement.style.fontFamily = "Arial, sans-serif";
  reportElement.style.position = "absolute";
  reportElement.style.left = "-9999px";
  reportElement.style.top = "0";

  const { colorClass, label } = data.config;
  const corHex =
    colorClass === "status-verde"
      ? "#2ecc71"
      : colorClass === "status-laranja"
        ? "#f39c12"
        : "#e74c3c";
  const corFundo =
    colorClass === "status-verde"
      ? "#eafaf1"
      : colorClass === "status-laranja"
        ? "#fef5e7"
        : "#fdedec";


  const logoClienteBase64 = await toBase64(
    user?.customCliente?.imgLogotipo || "",
  ).catch(() => "");

  const logoIkoneBase64 = await toBase64(
    "http://localhost:5000/imagens/logoikoneautomacao.png",
  ).catch(() => "");
  const imgIconeLinkBase64 = await toBase64(
    "https://monitorasompoapi.somee.com/imagens/link.png",
  ).catch(() => "");

  reportElement.innerHTML = `
    <div style="border: 1px solid #e0e0e0; border-radius: 12px; overflow: hidden; background: #fff;">
      <div style="background-color: ${corFundo}; padding: 30px 20px; text-align: center; border-bottom: 8px solid ${corHex};">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-bottom: 20px;">
            <tr>
                <td align="right" valign="middle" width="45%">
                    ${logoClienteBase64 ? `<img src="${logoClienteBase64}" style="max-height: 55px; max-width: 180px; display: block; margin-left: auto;">` : ""}
                </td>
                <td align="center" valign="middle" width="10%" style="padding: 0 10px;">
                    ${imgIconeLinkBase64 ? `<img src="${imgIconeLinkBase64}" style="height: 20px; width: 20px; opacity: 0.5;">` : ""}
                </td>
                <td align="left" valign="middle" width="45%">
                    ${logoIkoneBase64 ? `<img src="${logoIkoneBase64}" style="max-height: 55px; max-width: 180px; display: block;">` : ""}
                </td>
            </tr>
        </table>
        <h2 style="margin: 0; color: #2c3e50; font-size: 24px;">ÍKONE Monitora</h2>
        <div style="display: inline-block; padding: 6px 16px; background: #fff; border-radius: 20px; border: 1px solid #ddd; margin-top: 15px; color: ${corHex}; font-weight: bold; font-size: 13px; letter-spacing: 0.5px;">
           ● ${label}
        </div>
      </div>
      <div style="padding: 40px 30px;">
        <table style="width: 100%; border-collapse: collapse; color: #4a4a4a; font-size: 15px; line-height: 1.6;">
          <tr><td style="padding: 10px 0; font-weight: bold; width: 160px;">Alerta:</td><td>#${data.id} - ${data.descricao}</td></tr>
          <tr><td style="padding: 10px 0; font-weight: bold;">Data Alerta:</td><td>${transformDate(data.dataEvento, true)}</td></tr>
          ${data.dataNormalizacao ? `<tr><td style="padding: 10px 0; font-weight: bold;">Normalização:</td><td style="color: #2ecc71;">${transformDate(data.dataNormalizacao, true)}</td></tr>` : ""}
          <tr><td colspan="2" style="padding: 15px 0;"><hr style="border: none; border-top: 1px solid #eee; margin: 0;"></td></tr>
          <tr><td style="padding: 10px 0; font-weight: bold; vertical-align: top;">Procedimentos:</td><td>${data.procedimento || "Nenhum registrado."}</td></tr>
          <tr><td style="padding: 10px 0; font-weight: bold; vertical-align: top;">Descrição Detalhada:</td><td>${data.descricaoAlerta || ""}</td></tr>
        </table>
      </div>
      <div style="background: #f8f9fa; padding: 20px; text-align: center; font-size: 12px; color: #888; border-top: 1px solid #eee;">
        Este documento é um relatório oficial gerado pelo sistema <b>Íkone Automação e Sistemas</b>.
      </div>
    </div>
  `;

  document.body.appendChild(reportElement);

  try {

    const images = reportElement.getElementsByTagName("img");
    const imageLoadPromises = Array.from(images).map((img) => {
      if (img.complete) return Promise.resolve();
      return new Promise((resolve) => {
        img.onload = resolve;
        img.onerror = resolve;
      });
    });
    await Promise.all(imageLoadPromises);


    await new Promise((resolve) => setTimeout(resolve, 100));

    const canvas = await html2canvas(reportElement, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const imgProps = pdf.getImageProperties(imgData);
    const pdfHeight = (imgProps.height * (pdfWidth - 20)) / imgProps.width;

    pdf.addImage(imgData, "PNG", 10, 10, pdfWidth - 20, pdfHeight);
    pdf.save(`Relatorio_Alerta_${data.id}.pdf`);
  } catch (error) {
    console.error("Erro ao gerar PDF:", error);
  } finally {
    document.body.removeChild(reportElement);
  }
};

export default handleDownloadPDF;
